import { Modal } from '@common/components';
import { cn } from '@core/utils';

import type { ResponsiveDialogConfig } from '@/stores/DrawerStore';

interface DonationModalProps {
  opened: boolean;
  onClose?: () => void;
  header?: ResponsiveDialogConfig['modalHeader'];
  children: React.ReactNode;
  className?: string;
}

/**
 * 고향사랑기부에서 사용하는 모달\
 * 모든 뷰포트에서 모달을 사용하는 특수한 경우가 아니라면\
 * 반응형에 따라 적합한 컴포넌트를 렌더링 해주는 ResponsiveDialog를 대신 사용
 */
export const DonationModal = ({
  opened,
  onClose,
  header,
  children,
  className,
}: DonationModalProps) => {
  const renderHeader = () => {
    // string 타입인 경우
    if (typeof header === 'string') {
      return <Header title={header} />;
    }

    // 객체 타입인 경우
    if (header && typeof header === 'object' && 'title' in header) {
      return <Header title={header.title} description={header.description} />;
    }

    // ReactNode 타입인 경우
    return header;
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      header={renderHeader()}
      headerClassName="px-32 mb-24"
      asChild
      className={cn(
        //* 480px이 기본 사이즈
        '!max-h-[90%] !min-h-0 w-full !min-w-0 max-w-[480px] !px-0 text-start',
        className,
      )}
      closeButton
    >
      {/* Slot되는 엘리먼트 */}
      <div>
        <div className="px-32">{children}</div>
      </div>
    </Modal>
  );
};

interface HeaderProps {
  title: string;
  description?: string;
}

const Header = ({ title, description }: HeaderProps) => {
  return (
    <div>
      <h2 className="whitespace-pre-line typo-inherit">{title}</h2>
      {description ? (
        <p className="mt-12 whitespace-pre-line font-400 text-Gray-700 typo-body3">
          {description}
        </p>
      ) : null}
    </div>
  );
};
